import { useTranslation } from 'react-i18next';

export default function ResearchToolCard({ item, onOpen }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={() => onOpen(item)}
      className="card flex w-full flex-col items-start gap-2 text-left"
    >
      <span className="text-[0.7rem] font-semibold uppercase tracking-[0.15em] text-gold">
        {t(`researchTools.types.${item.type}`)}
      </span>
      <h3 className="font-serif text-lg font-semibold text-cream">{item.name}</h3>
      {item.institution && <p className="text-sm text-ink-secondary">{item.institution}</p>}
      {item.description && (
        <p className="line-clamp-3 text-sm text-ink-secondary">{item.description}</p>
      )}
    </button>
  );
}
